import React from 'react';
import update from 'immutability-helper';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import BlockEditor from '../../../block-editor/Editor';
import Entity from '../../../contentful/Entity';

class MakeComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  /* Handle submit */
  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }


  handleAssetChange(name, asset) {
    const change = {
      make: {}
    };

    change.make[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    return this.handleAssetChange(e.target.name, e.target.value);
  }

  render() {
    const make = this.props.make;

    const predefinedTags = ['Merke'];
    if (make.name !== '') {
      predefinedTags.push(make.name);
    }

    return (
      <section className="mf-equipment-equipment">
        <ol className="breadcrumb mf-margin-top-20">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to="/merker/">Merker</Link></li>
          <li className="active">{make.name}</li>
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <h1>
                  {make.name} <PublishStatusDot entry={make} /><br/>
                  <small>merke</small>
                </h1>
              </div>

              <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
                {this.props.working &&
                  <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                {!make.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    <span>Lagre endringer</span>
                  </button>
                }
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={!(make.draft || make.updated) || this.props.working || this.props.modified || make.archived}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
              </div>
            </div>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <label>Forsideinnhold</label>
              <BlockEditor
                blocks={make.frontpageContent}
                onChange={(blocks) => this.handleAssetChange('frontpageContent', blocks)}
                disabled={this.props.working}
                allowVideo
                predefinedTags={predefinedTags}
              />
            </div>
            <div className="col-xs-12 col-md-6">
              {!make.isInternal && <div className="form-group">
                <div className="clearfix mf-margin-bottom-10">
                  <label>Ekstern link</label>
                  <input type="text" className="form-control" name="webpageUrl" defaultValue={make.webpageUrl} disabled={this.props.working} onChange={this.handleFieldChange}/>
                </div>
              </div>}
              <div className="form-group">
                <div className="mf-margin-bottom-10">
                  <label>Metadata</label>
                  <Link className="btn btn-default pull-right" to={`/opengraph/new/${make.id}`}>Opprett metadata</Link>
                </div>
                {this.props.openGraphs && this.props.openGraphs.map((og) => {
                  return <Entity disabled={this.props.working} allowEdit={`/opengraph/make/${og.id}`} key={og.id} entity={og} />;
                })}
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default MakeComponent;
